import { Auth } from "aws-amplify";

const configureAmplify = (userPoolWebClientId, type = "USER_PASSWORD_AUTH") => {
  const region = process.env.REACT_APP_REGION;
  const userPoolId = process.env.REACT_APP_USERPOOLID;
  const identityPoolId = process.env.REACT_APP_IDENTITYPOOLID;
  
  if (!userPoolWebClientId || userPoolWebClientId.trim() === "") {
    console.error("Amplify config aborted: userPoolWebClientId missing");
    return;
  }
  Auth.configure({
    Auth: {
      region: region,
      userPoolId: userPoolId,
      userPoolWebClientId: userPoolWebClientId,
      identityPoolId: identityPoolId,
      authenticationFlowType: type, //for mfa ->type="USER_PASSWORD_AUTH" DEFAULT
      cookieStorage: null,
    },
    // identityPoolId: process.env.REACT_APP_IDENTITYPOOLID,
    // region: process.env.REACT_APP_REGION,
    // userPoolId: process.env.REACT_APP_USERPOOLID,
    // userPoolWebClientId: userPoolWebClientId,
    // authenticationFlowType: type, //for mfa ->type="USER_PASSWORD_AUTH" DEFAULT
  });
};

export default configureAmplify;
